import { PhotoStage } from './shared/photoStage.js';

export const RIG = 'forbidden';

export const PROFILE = {
  id: 'goldenhour',
  family: 'photographic',
  danceability: 0.70,
  requiresTier: 0,
  energyLevel: 0.58,
  bpmMin: 95,
  bpmMax: 128,
  movement: 0.55,
  tonality: 0.75,
  enabled: true
};

// GOLDENHOUR: the festival stage at sunset (scene c of assets/mainstage).
// Warm palettes (amber, rose, gold), wide slow beams, phones up often, the
// cover on the screens most of the time, golden confetti on the drop, flames
// rarely; no strobe, no blinders; the intensity is capped at 0.7 by adapt.js;
// the sky of the photograph is never recoloured by the projectors
// (protectSky). House, melodic, pop, disco. Shared/photoStage.js does the rest.
const CONFIG = {
  id: 'goldenhour', scene: 'c',
  program: { lasers: false, strobe: false, blinders: false, flames: 'rare', co2: false, confetti: [0xffd34a, 0xffb020, 0xfff0a0, 0xe8a030], haze: 0.35, beamSpread: [0.06, 0.14], beamGain: 0.8, programs: ['wide', 'fan', 'sweep'], arms: 0.6, phones: 0.9, bounce: 0.7 },
  palettes: [[0xffb347, 0xff6f91, 0xffd700], [0xffa040, 0xff8fa3, 0xffe680], [0xff7f50, 0xffc0cb, 0xffd27f]],
  screens: { mix: { content: 0.3, cover: 0.55, title: 0.15 }, exclude: ['shapes'] },
  shots: { prefer: ['wide', 'crowd', 'left', 'right', 'dj'], build: 'wide', drop: ['wide', 'crowd'], calm: ['wide', 'crowd'] },
  intensityCap: 0.7, protectSky: true
};

export class GoldenhourVisualizer extends PhotoStage {
  constructor(options) { super(CONFIG, options); }
}
